import * as React from 'react';
import FelaComponent from './fela-component';
var rule = function (_a) {
    var theme = _a.theme;
    return ({
        fontFamily: theme.fontFamily
    });
};
export var Text = function (_a) {
    var _b = _a.component, component = _b === void 0 ? 'span' : _b;
    return React.createElement(FelaComponent, { rule: rule, render: component });
};
Text.displayName = 'Text';
export default Text;
//# sourceMappingURL=text.js.map